module.exports = __webpack_public_path__ + "static/media/zilla.6c3ac6af.svg";